<template>
  <div class="h-full">
    <!-- SideBar Here -->
    <div class="h-full">
      <div class=" h-full pt-20 lg:pt-20 mx-auto">
        <div class="flex h-full">
          <aside class="flex-shrink-0 w-80 flex flex-col border-r transition-all duration-300 lg:block"
            :class="{ '-ml-80': !sidebarOpen }" style="overflow-y:auto; scrollbar-width: thin;">
            <div
              class="justify-center flex border-solid shadow-[rgba(0,0,15,0.2)_0px_1px_3px_0px] relative z-auto border-gray-100 border-t border-b">
              <div class="py-1 pl-4 font-medium text-xl text-slate-600 ">
                Filters
              </div>
              <div class="flex order-2 justify-center pr-4 items-center ml-auto">
                <i class="pi pi-times" style="cursor:pointer;" @click="sidebarOpen = false"></i>
              </div>
            </div>
            <nav class="flex-1 flex flex-col bg-[#ffffff] pt-3 ">
              <SidebarFilter :sideBarState="state" :bowlers="bowlers" :batters="batters" :venues="venues">
              </SidebarFilter>
            </nav>
          </aside>
          <button class="p-1 mr-4" @click="sidebarOpen = !sidebarOpen"></button>
          <!-- Card -->
          <div v-if="!errorStatus.isError" class="flex flex-col w-full pr-5 overflow-x-hidden"
            style="scrollbar-width: thin;" :class="{ 'tab-open-width': sidebarOpen }">
            <div class="-m-1.5 filters-header-bar">
              <!-- Filters -->
              <div class="p-1.5 min-w-full inline-block align-middle">
                <div class=" bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden p-4 mb-2 items-end">
                  <!-- Columns -->
                  <div class="float-right">
                    <MultiSelect :showToggleAll=false v-model="selectedColumns" :options="availableColumns"
                      optionLabel="name" placeholder="Columns" :maxSelectedLabels=0 selectedItemsLabel="Columns"
                      class="w-full md:w-[10rem] mr-2 shadow-none" @change="startQueryTimer()"
                      pt:wrapper:class="!max-h-96" />
                    <!-- Copy Query -->
                    <Button class="bg-[#e6ecf0] text-[#041e42] hover:bg-[#d7dde0] my-1 h-8 px-2 rounded"
                      label="Copy Query" @click="copyQuery()" />
                  </div>
                  <div class="flex flex-wrap items-center">
                    <!-- Batters -->
                    <div v-if="!sidebarOpen" class="flex justify-center mr-2">
                      <Button label="Batters" class="h-8 my-1 px-1.5 bg-[#e6ecf0] hover:bg-[#d7dde0] text-[#041e42]"
                        @click="sidebarOpen = !sidebarOpen">Open Filters</Button>
                    </div>
                    <!-- Batters -->
                    <div class="flex justify-center mr-2">
                      <Button label="Batters" class="h-8 my-1 px-1.5 bg-[#e6ecf0] hover:bg-[#d7dde0] text-[#041e42]"
                        @click="batters = []; populateFilters('batterOption'); showFiltersDialog('Batters', 'striker.player_id', 'striker.display_name'); dialogVisible = true;"><img
                          class="pr-1.5 h-5 w-auto " src="../assets/batter-blue.svg"
                          alt="bowlers logo" />Batters</Button>
                    </div>
                    <!-- Bowlers -->
                    <div class="flex justify-center mr-2">
                      <Button label="Bowlers"
                        class="h-8 my-1 py-0.5 px-1.5 bg-[#e6ecf0] hover:bg-[#d7dde0] text-[#041e42]"
                        @click="bowlers = []; populateFilters('bowlerOption'); showFiltersDialog('Bowlers', 'bowler.player_id', 'bowler.display_name'); dialogVisible = true;"><img
                          class="pr-1.5 h-5 w-auto " src="../assets/bowler-blue.svg"
                          alt="bowlers logo" />Bowlers</Button>
                    </div>
                    <!-- Venues -->
                    <div class="flex justify-center mr-2">
                      <Button label="Venues" class="h-8 my-1 px-1.5 bg-[#e6ecf0] hover:bg-[#d7dde0] text-[#041e42]"
                        @click="venues = []; populateFilters('venueOption'); showFiltersDialog('Venues', 'venues.stadium', 'venues.stadium'); dialogVisible = true;"><img
                          class="pr-1.5 h-5 w-auto " src="../assets/venue-blue.svg" alt="venues logo" />Venues</Button>
                    </div>
                    <!-- Clear All -->
                    <div>
                      <button class="bg-[#041e42] hover:bg-slate-500 text-white font-bold my-1 h-8 px-2 rounded"
                        @click="stateStore.clearAllSelected(state.selectedFilters); setTableRows();">
                        Clear All
                      </button>
                    </div>
                  </div>
                  <DynamicDialog />

                  <!-- Filter Tags -->
                  <template v-for="(filter, key) in state.selectedFilters" :key="key">
                    <div v-for="(filterType, key) in filter" :key="key">
                      <div v-if="filterType['selected'] && filterType.selected.length > 0"
                        class="flex flex-wrap mt-1.5">
                        <FilterTags v-for="(tag, i) in  filterType['selected'] " :key=tag :filterValue=tag
                          :nameKey="Object.keys(tag)[1]" :index=i :icon="filterType['icon']"
                          :type="(Object.keys(filter).find(key => filter[key] === filterType))"
                          v-on:remove-tag="filterType.selected.splice(i, 1);" class="mb-0.5">
                        </FilterTags>
                        <button class=" text-sm text-[#fff] mb-0.5 px-2 py-0.5 bg-[#041e42]"
                          @click="filterType.selected = []; setTableRows();">
                          Clear</button>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- End of Filter Tags -->
              </div>
            </div>
            <!-- End Filters -->

            <!-- Table Section -->
            <div v-if="!state.isLoading" class="w-full h-full mx-auto pt-2">
              <!-- Card -->
              <div class="flex flex-col h-full">
                <div class="-m-1.5 h-full">
                  <div class="p-1.5 inline-block align-middle max-w-full w-full h-full">
                    <div v-if="count != null && selectedColumns.length > 0"
                      class="bg-white border border-gray-200 rounded-xl shadow-sm ">
                      <!-- Table -->
                      <div style="overflow-y:auto; scrollbar-width: thin;" class="border rounded-t-xl">
                        <table class="min-w-full divide-y divide-gray-200 ">
                          <thead class="bg-gray-50 ">
                            <tr>
                              <!-- eslint-disable-next-line vue/no-v-for-template-key -->
                              <template v-for="( item ) in  selectedColumns " :key="item">
                                <th scope="col" class="px-6 py-3 text-start">
                                  <div class="flex items-center gap-x-2">
                                    <span
                                      class="text-xs text-nowrap font-semibold uppercase tracking-wide text-gray-800 ">
                                      {{ item.name }}
                                    </span>
                                  </div>
                                </th>
                              </template>
                            </tr>
                          </thead>
                          <!-- eslint-disable-next-line vue/no-v-for-template-key -->
                          <template v-for="( item, index ) in  count.slice(state.pageOffset, state.pageOffset + state.pageLimit) " :key="item.name">
                            <tbody class="divide-y divide-gray-200 ">
                              <tr class="bg-white hover:bg-gray-50 cursor-pointer">
                                <!-- eslint-disable-next-line vue/no-v-for-template-key -->
                                <template v-for="( header ) in  selectedColumns " :key="header">
                                  <td class="size-px whitespace-nowrap relative">
                                    <button v-if="item[header.key] && item[header.key].length < 40"
                                      @click="router.push('/play?q=' + count[index]['plays.play_key'])" type="button"
                                      class="block w-full text-start">
                                      <span class="block px-6 py-[4px]">
                                        <span class="font-mono text-sm text-gray-800">
                                          {{ item[header.key] ? item[header.key] : '-' }}
                                        </span>
                                      </span>
                                    </button>
                                    <Inplace v-else-if="item[header.key]" class="inplace pr-4" :pt="{
                                        display: {
                                          class: ['p-1'],
                                          style: { 'box-shadow': 'none' }
                                        },
                                      }" :closable="false" :active="isInplaceOpen[item[header.key]]"
                                      @open="isInplaceOpen[item[header.key]] = true">
                                      <template #display>
                                        <span class="font-mono text-sm text-gray-800 py-1 px-6"
                                          v-tooltip.bottom="{ value: 'Expand', showDelay: 500, pt: { text: 'text-xs px-2 py-1' } }">
                                          {{ item[header.key].slice(0, 18) }}...
                                        </span>
                                      </template>
                                      <template #content>
                                        <span
                                          class="block font-mono text-sm text-gray-800 w-96 min-w-min overflow-auto whitespace-normal py-1 px-6"
                                          @click="isInplaceOpen[item[header.key]] = false">
                                          <span>
                                            {{ item[header.key] }}
                                          </span>
                                        </span>
                                        <div class="copy-button float-right">
                                          <Button icon="pi pi-copy text-gray-800 text-base"
                                            class="hover:bg-gray-50 h-8 "
                                            @click="copyLargeDataValue(item[header.key]);"></Button>
                                        </div>
                                      </template>
                                    </Inplace>
                                    <button v-else type="button" class="block"
                                      @click="router.push('/play?q=' + count[index]['plays.play_key'])">
                                      <span class="block px-6 py-1">
                                        <span class="font-mono text-sm text-gray-800">{{ '-' }}</span>
                                      </span>
                                    </button>
                                  </td>
                                </template>
                              </tr>
                            </tbody>
                          </template>
                        </table>
                      </div>

                      <!-- Footer -->
                      <div class="px-6 py-4 grid gap-3 md:flex md:justify-between md:items-center">
                        <div>
                          <p class="text-sm text-gray-700">
                            Showing
                            {{ ' ' }}
                            <span v-if="state.total <= 0" class="font-medium">{{ 0 }}</span>
                            <span v-else class="font-medium">{{ state.usersPerceivedOffset + 1 }}</span>
                            {{ ' ' }}
                            to
                            {{ ' ' }}
                            <span v-if="state.total > state.usersPerceivedOffset + state.pageLimit" class="font-medium">
                              {{ state.usersPerceivedOffset + state.pageLimit }}
                            </span>
                            <span v-else class="font-medium">{{ state.total }}</span>
                            {{ ' ' }}
                            of
                            {{ ' ' }}
                            <span class="font-medium">{{ state.total }}</span>
                            {{ ' ' }}
                            results
                          </p>
                        </div>
                        <div>
                          <div class="inline-flex gap-x-2">
                            <button v-if="state.usersPerceivedOffset != 0" type="button" @click="pageChangePrev()"
                              class="py-1 px-2  inline-flex items-center gap-x-2 text-m font-medium rounded-lg h-8 border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none">
                              <i class="pi pi-angle-left text-lg text-gray-800"></i>
                              Prev
                            </button>
                            <button v-if="state.total > state.pageOffset + state.windowOffset + state.pageLimit"
                              type="button" @click="pageChangeNext()"
                              class="py-1 px-2  inline-flex items-center gap-x-2 text-m font-medium rounded-lg h-8 border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none">
                              Next
                              <i class="pi pi-angle-right text-lg text-gray-800"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="selectedColumns.length == 0" class="text-center p-5 h-full content-center">
                      <div class="flex w-full justify-center">
                        <h1 class="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                          No columns selected
                        </h1>
                      </div>
                      <p class="mt-1 text-base leading-7 text-gray-600">Please select a column to display
                      </p>
                    </div>
                    <div v-else class="text-center p-5">
                      <div class="flex w-full justify-center">
                        <h1 class="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                          No results
                        </h1>
                      </div>
                      <p class="mt-1 text-base leading-7 text-gray-600">Sorry, we cannot find any results matching the
                        parameters
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="state.isLoading" class="w-full flex pb-6 pt-6">
              <ProgressSpinner class="justify-center w-90 h-90" attrs-color-black strokeWidth="5" animationDuration="1s"
                aria-label="Loading" />
            </div>
          </div>
          <div v-else-if="errorStatus.isError" class="w-full flex justify-center">
            <ErrorMessage :message=errorStatus.errorMessage :status-code="errorStatus.statusCode"></ErrorMessage>
          </div>
        </div>
      </div>
    </div>
    <!-- End Table Section -->
    <div class="card flex justify-content-center">

    </div>
    <Toast pt:root:class="w-60" />
  </div>
</template>

<script lang='ts' setup>

import 'primeicons/primeicons.css'
import MultiSelect from 'primevue/multiselect'
import Button from 'primevue/button'
import Inplace from 'primevue/inplace';
import { useToast } from "primevue/usetoast";
import Toast from 'primevue/toast';
import SidebarFilter from '../components/SidebarFilter.vue'
import ErrorMessage from '../components/ErrorRefreshPage.vue'
import { Ref, ref, watch, onMounted, computed } from 'vue'
import { SearchFilter, Data } from '@/models/queryBuilder'
import FiltersDialog from '../components/FiltersDialog.vue';
import FilterTags from '../components/FilterTags.vue';
import { useDialog } from 'primevue/usedialog';
import DynamicDialog from 'primevue/dynamicdialog';
import { useRouter, useRoute } from 'vue-router'
import ProgressSpinner from 'primevue/progressspinner';
import { useApiStore } from "../store/api/api";
import { querystate } from "../store/tableQuery/index"

let sidebarOpen = ref(false);
const api = useApiStore();
const stateStore = querystate();
const route = useRoute()
const router = useRouter()
const count: Ref<Data[]> = ref([])//query table results
const dialogVisible = ref(false);
const dialog = useDialog();
const toast = useToast();
const isInplaceOpen: Ref<object> = ref({})

let columnsTimer: any;
let filtersTimer: any;
const waitTime = 800;
let queueLength = 0
let hasBeenMounted = ref(false)

/**
 * Sliding window setup requirement:
 * trigger < slidingWindowSize / 3
 */
let slidingWindowSize = 17
let trigger = 5

const batters: Ref<Data[]> = ref([]);
const bowlers: Ref<Data[]> = ref([]);
const venues: Ref<Data[]> = ref([]);

const state = ref({
  queryTable: computed(() => {
    return stateStore.getTableQuery;
  }),
  queryDropdown: computed(() => {
    return stateStore.getDropDownQuery;
  }),
  options: computed(() => {
    return stateStore.getOptions;
  }),
  selectedFilters: computed(() => {
    return stateStore.getFilters;
  }),
  isLoading: true,
  total: 0,
  pageLimit: 28,
  pageOffset: 0,
  windowOffset: 0,
  usersPerceivedOffset: 0,

});

const errorStatus = ref({
  isError: false,
  errorMessage: "",
  statusCode: 0,
})

const selectedColumns = ref([
  { name: 'Home Team', key: "home_team.name" },
  { name: 'Away Team', key: "away_team.name" },
  { name: 'Match Start Date', key: 'matches.start_date' },
  { name: 'Match Country', key: 'matches.country' },
  { name: 'Stadium City', key: 'venues.city' },
  { name: 'Striker Name', key: "striker.display_name" },
  { name: 'Non-Striker Name', key: "non_striker.display_name" },
  { name: 'Bowler Name', key: "bowler.display_name" },
  { name: 'Batting Team Name', key: 'batting_team.name' },
  { name: 'Bowling Team Name', key: 'bowling_team.name' },
  { name: 'Day / Night', key: 'matches.day_nighter' },
  { name: 'Ball', key: "plays.ball" },
  { name: 'Innings', key: "plays.innings" },
  { name: 'Over', key: "plays.over" },
  { name: 'Delivery', key: "plays.delivery" },
])

const availableColumns = [
  { name: 'Play Key', key: 'plays.play_key' },
  { name: 'Match Start Date', key: 'matches.start_date' },
  { name: 'Home Team', key: "home_team.name" },
  { name: 'Away Team', key: "away_team.name" },
  { name: 'Match Country', key: 'matches.country' },
  { name: 'Stadium City', key: 'venues.city' },
  { name: 'Striker Name', key: "striker.display_name" },
  { name: 'Non-Striker Name', key: "non_striker.display_name" },
  { name: 'Bowler Name', key: "bowler.display_name" },
  { name: 'Batting Team Name', key: 'batting_team.name' },
  { name: 'Bowling Team Name', key: 'bowling_team.name' },
  { name: 'Day / Night', key: 'matches.day_nighter' },
  { name: 'Match Type', key: 'matches.match_type' },
  { name: 'Stadium Name', key: 'venues.stadium' },
  { name: 'Innings', key: "plays.innings" },
  { name: 'Over', key: "plays.over" },
  { name: 'Delivery', key: "plays.delivery" },
  { name: 'Ball', key: "plays.ball" },
  { name: 'Time Stamp', key: 'plays.timestamp' },

  { name: 'Smooth XML', key: 'plays.smooth_xml' },
  { name: 'Bat Arc', key: 'plays.bat_arc' },
  { name: 'Swing Arc', key: 'plays.swing_arc' },
]


onMounted(async () => {
  hasBeenMounted.value = false
  stateStore.clearAllSelected(state.value.selectedFilters)
  await setFiltersFromQueryParams()
  setTableRows()
  setTableCols()
  intialTableQuerySetup()
  setURLQueryParams()
  addSubmitToQueue()

  await api.fetchBattersList().then((value: any) => {
    if (value instanceof Error) {
      errorStatus.value.isError = true
    } else {
      batters.value = value as unknown as Data[];
    }
  })
  await api.fetchBowlersList().then((value: any) => {
    if (value instanceof Error) {
      errorStatus.value.isError = true
    } else {
      bowlers.value = value as unknown as Data[];
    }
  })
  await api.fetchVenueList().then((value: any) => {
    if (value instanceof Error) {
      errorStatus.value.isError = true
    } else {
      venues.value = value as unknown as Data[];
    }
  })
  hasBeenMounted.value = true
})

window.addEventListener("popstate", (event) => {
  location.reload()
});

watch(state.value.selectedFilters, (newFilters, oldFilters) => {
  // Ensures the onMounted api call is not overridden and the dialog is not open
  if (hasBeenMounted.value && !dialogVisible.value) {
    state.value.isLoading = true
    clearTimeout(filtersTimer)
    filtersTimer = setTimeout(setWindowToStart, waitTime)
    setURLQueryParams()
  }
  // Still add filters to URL if dialog is open
  if (dialogVisible.value) {
    setURLQueryParams()
  }
})

/**
 * Watcher for menu bar statSearch press - refreshes table results
 */
watch(() => route.query, (newQuery) => {
  if (Object.keys(newQuery).length == 0) {
    stateStore.clearAllSelected(state.value.selectedFilters)
    intialTableQuerySetup()
  }
})

/**
 * @param null
 * @returns nothing
 * Sets the selected filters according to the URL params
 */
function setFiltersFromQueryParams() {
  for (const [catorgoryKey, filter] of Object.entries(route.query)) {
    const keys = catorgoryKey.split("-")
    if (keys[0] !== "page") {
      state.value.selectedFilters[keys[0]][keys[1]].selected = JSON.parse(filter)
    }
  }
}

/**
 * @param null
 * @returns nothing
 * Adds params to the URL representing selected filters 
 */
function setURLQueryParams() {
  let URL = "/statsearch?"
  for (const [catorgoryKey, filter] of Object.entries(state.value.selectedFilters)) {
    for (const [key, type] of Object.entries(filter)) {
      if (type.selected.length > 0) {
        URL = URL + catorgoryKey + "-" + key + "=" + JSON.stringify(type.selected) + "&"
      }
    }
  }
  URL = URL + "page=" + state.value.usersPerceivedOffset + "&"
  URL = URL.slice(0, -1)
  router.push(URL)
}

/**  
* @param null
* @returns 
* Using the dropdown arrays, concats them together to form one object array
* Iterates through the keys appending the values to one array per key
* Appends objects of type SearchFilter to the filterlist to be used in the query
* Then executes the query
*/
async function submit(queuePlace: number) {
  let filtersTemp: any[] = []
  state.value.queryTable.filters = []

  filtersTemp = stateStore.getValue(state.value.selectedFilters).flat(1);
  state.value.queryTable.filters = createFilterList(filtersTemp, state.value.queryTable.filters.concat(state.value.options.filters.countOption))

  state.value.isLoading = true

  let queryCopy = JSON.parse(JSON.stringify(state.value.queryTable))
  await api.fetchMainTable(queryCopy).then((value) => {
    if (queuePlace === queueLength) {
      if (value instanceof Error) {
        errorStatus.value.errorMessage = value.message
        errorStatus.value.isError = true
        errorStatus.value.statusCode = value.code
      } else {
        count.value = value[0] as unknown as Data[];
        state.value.total = value[1];
        queueLength = 0
        // Catches case that query page number exceeds total results
        if (state.value.total < state.value.queryTable.offset) {
          setWindowToStart()
          setURLQueryParams()
        }
      }
      state.value.isLoading = false
      isInplaceOpen.value = {}
      count.value.forEach(element => {
        Object.values(element).forEach(value => {
          isInplaceOpen.value[value] = false
        });
      });
    }
  })
}

/**
 * Wait until user finishes removing filter tags before submitting
 */
function addSubmitToQueue() {
  queueLength = queueLength + 1
  const queuePlace = queueLength
  submit(queuePlace)
  state.value.isLoading = true
}

/**
 * Sets the Table Query Limit based off window height
 */
function setTableRows() {
  const headerHeight = document.getElementsByTagName("nav")[0].getBoundingClientRect().height
  const filtersHeaderBarHeight = document.getElementsByClassName("filters-header-bar")[0].getBoundingClientRect().height
  const allowedPaddingAndArbituaryValues = 137
  let tempLimit = Math.floor((window.innerHeight - headerHeight - filtersHeaderBarHeight - allowedPaddingAndArbituaryValues) / (Number(window.getComputedStyle(document.querySelector("html")).getPropertyValue("line-height").replace(/[^0-9.]/g, '')) + 11) )
  state.value.pageLimit = (tempLimit > 4 ? tempLimit : 5)
  state.value.queryTable.limit = state.value.pageLimit * slidingWindowSize
}

/**
 * Sets the default selected columns based of window width
 */
function setTableCols() {
  let tempCols = Math.floor(window.innerWidth / 180)
  selectedColumns.value = availableColumns.slice(1, tempCols > 2 ? tempCols : 3)
  state.value.queryTable.dimensions = selectedColumns.value.map((x) => x.key)
  state.value.queryTable.dimensions.push("plays.play_key")
}

/**
 * When user changes columns selection
 * Creates new sliding window from current page with new dimensions
 */
function columnsChange() {
  intialTableQuerySetup()
  state.value.queryTable.dimensions = selectedColumns.value.map((x) => x.key)
  state.value.queryTable.dimensions.push("plays.play_key")
  state.value.queryTable.dimensions = [...new Set(state.value.queryTable.dimensions)]
  addSubmitToQueue()
}

function startQueryTimer() {
  state.value.isLoading = true
  clearTimeout(columnsTimer)
  columnsTimer = setTimeout(columnsChange, waitTime)
}

/**
 * Prepares the queryTable object for intial fetch from current page
 */
function intialTableQuerySetup() {
  let offset: number = Object.keys(route.query).length > 0 && route.query.page ? Number(route.query.page) : 0

  // Calculate the remainder and remove from offset to ensure that if the user navigates to the first page of results, the offset will be zero
  let remainder = offset % state.value.pageLimit
  offset -= remainder

  // Calc the query offset to retrieve the appropriate window of data
  let numberOfPagesToLeft = Math.floor((slidingWindowSize) / 2) * state.value.pageLimit
  // Set offset to zero if negative
  state.value.queryTable.offset = offset - (numberOfPagesToLeft) < 0 ? 0 : offset - (numberOfPagesToLeft)

  // Intialise Offsets
  state.value.usersPerceivedOffset = offset
  state.value.windowOffset = state.value.queryTable.offset
  state.value.pageOffset = state.value.windowOffset == 0 ? offset : numberOfPagesToLeft
  state.value.queryTable.limit = state.value.pageLimit * slidingWindowSize
}

/**
 * Set all offsets to zero and query limit to full window size 
 */
function setWindowToStart() {
  state.value.queryTable.offset = 0;
  state.value.pageOffset = 0
  state.value.usersPerceivedOffset = 0
  state.value.windowOffset = 0
  state.value.queryTable.limit = state.value.pageLimit * slidingWindowSize
  addSubmitToQueue()
}

/**
 * Copies current query state to clipboard and alerts user
 */
function copyQuery() {
  navigator.clipboard.writeText(JSON.stringify(state.value.queryTable))
  toast.add({ severity: 'info', detail: 'Copied to clipboard', life: 1800 });
}

/**
 * Copies current query state to clipboard and alerts user
 */
function copyLargeDataValue(value: string) {
  navigator.clipboard.writeText(value)
  toast.add({ severity: 'info', detail: 'Copied to clipboard', life: 1800 });
}

/**
 * @param title
 * @param id
 * @param name
 * @returns 
 * Creates a pop up filter dialog box
 */
function showFiltersDialog(title: string, id: string, name: string) {
  let dataObject;
  let dataModel;
  let path: string
  dataModel = state;
  switch (title) {
    case "Batters":
      dataObject = batters
      path = "batters"
      break;
    case "Bowlers":
      dataObject = bowlers
      path = "bowlers"
      break;
    default:
      dataObject = venues
      path = "venues"
      break;
  }

  dialog.open(FiltersDialog, {
    props: {
      header: title,
      style: {
        width: '65%',
        padding: '4px',
      },
      dismissableMask: true,
      modal: true,
    },
    onClose: (e) => {
      dialogVisible.value = false
      setTableRows()
      setWindowToStart()
    },

    data: {
      dataObject: dataObject,
      dataModel: dataModel,
      objectId: id,
      objectName: name,
      path: path,
      subcat: "common"
    },
  });
}

/**
 * Navigates to previous page of table conent
 * Implements sliding window technique for optimisation
 */
async function pageChangePrev() {
  state.value.pageOffset -= state.value.pageLimit
  state.value.usersPerceivedOffset -= state.value.pageLimit

  // Loading Spinner
  if (state.value.pageOffset == 0 || count.value[state.value.pageOffset] == undefined) state.value.isLoading = true

  // If trigger is hit or has reached end of loaded data - Move sliding window
  if ((state.value.pageOffset == (trigger * state.value.pageLimit) || state.value.pageOffset == 0) && state.value.windowOffset > 0) {

    // Window is less than trigger length away from start of data
    if (state.value.windowOffset < state.value.pageLimit * trigger && state.value.windowOffset > 0) {
      // Change query limit so as not to grab duplicate values from cube
      state.value.queryTable.limit = state.value.windowOffset
      state.value.windowOffset = 0
      state.value.queryTable.offset = 0
      count.value.splice(-state.value.queryTable.limit, state.value.queryTable.limit)

      // Window is at the end of data
    } else if ((state.value.total - state.value.windowOffset) < (slidingWindowSize * state.value.pageLimit)) {
      // remove any trailing data from end of window to prepare for the addition of a triggers length to start of window
      if ((state.value.total - state.value.windowOffset) > (slidingWindowSize - trigger) * state.value.pageLimit) {
        count.value.splice(-(state.value.total - state.value.windowOffset) % ((slidingWindowSize - trigger) * state.value.pageLimit), count.value.length % ((slidingWindowSize - trigger) * state.value.pageLimit))
      }

      state.value.queryTable.limit = state.value.pageLimit * trigger
      state.value.windowOffset -= (state.value.pageLimit * trigger)
      state.value.queryTable.offset = state.value.windowOffset

      // Window is in the middle of data
    } else {
      state.value.queryTable.limit = state.value.pageLimit * trigger

      // Remove trigger length of data from end of window
      count.value.splice(-state.value.queryTable.limit, state.value.queryTable.limit)

      state.value.windowOffset -= (state.value.pageLimit * trigger)
      state.value.queryTable.offset = state.value.windowOffset
    }

    let copyOfQuery = JSON.parse(JSON.stringify(state.value.queryTable))
    await api.fetchMainTable(copyOfQuery).then(
      (value: any) => {
        let response = value[0] as unknown as Data[];
        state.value.total = value[1];
        state.value.pageOffset += copyOfQuery.limit
        count.value.unshift(...response)
      })
  }

  setURLQueryParams();
  state.value.isLoading = false
}

/**
 * Navigates to next page of table conent
 * Implements sliding window technique for optimisation
 */
async function pageChangeNext() {
  state.value.pageOffset += state.value.pageLimit
  state.value.usersPerceivedOffset += state.value.pageLimit

  if (state.value.pageOffset >= count.value.length) state.value.isLoading = true

  if ((state.value.pageOffset == (state.value.pageLimit * slidingWindowSize) - (trigger * state.value.pageLimit) || state.value.pageOffset == (state.value.pageLimit * slidingWindowSize))
    && state.value.total > state.value.windowOffset + state.value.pageOffset + (state.value.pageLimit * trigger)) {

    // Subtract trigger pages from pageOffest 
    state.value.pageOffset -= state.value.pageLimit * trigger
    // remove trigger pages from start
    count.value.splice(0, state.value.pageLimit * trigger)

    state.value.queryTable.limit = state.value.pageLimit * trigger

    // Move windowOffset forward by 4 pages
    state.value.windowOffset += state.value.pageLimit * trigger
    state.value.queryTable.offset = state.value.windowOffset + (state.value.pageLimit * (slidingWindowSize - trigger))
    // Set query offset to end of count data
    let copyOfQuery = JSON.parse(JSON.stringify(state.value.queryTable))
    await api.fetchMainTable(copyOfQuery).then(
      (value: any) => {
        let response = value[0] as unknown as Data[];
        state.value.total = value[1];
        count.value.push(...response)
      })
  }

  setURLQueryParams();
  state.value.isLoading = false
}

/**
 * @param filterName filter dimensions ( batter options etc)
 * populates the selected field based on prior inputted filters results
 */
async function populateFilters(filterName: keyof typeof state.value.options.dimensions) {
  let filtersTemp: SearchFilter[] = []

  switch (filterName) {
    case "batterOption":
      filtersTemp = filtersTemp.concat(state.value.selectedFilters.common.bowlers.selected, state.value.selectedFilters.common.venues.selected)
      await api.fetchBattersListWithFilters(createFilterList(filtersTemp, state.value.options.filters[filterName])).then(
        (value) => {
          batters.value = value as unknown as Data[];
        })
      break;
    case "bowlerOption":
      filtersTemp = filtersTemp.concat(state.value.selectedFilters.common.batters.selected, state.value.selectedFilters.common.venues.selected)
      await api.fetchBowlersListWithFilters(createFilterList(filtersTemp, state.value.options.filters[filterName])).then(
        (value) => {
          bowlers.value = value as unknown as [];
        })
      break;
    default:
      filtersTemp = filtersTemp.concat(state.value.selectedFilters.common.batters.selected, state.value.selectedFilters.common.bowlers.selected)
      await api.fetchVenuesListWithFilters(createFilterList(filtersTemp, state.value.options.filters[filterName])).then(
        (value) => {
          venues.value = value as unknown as [];
        })
      break;
  }
}

/**
 * @param filtersTemp
 * @param filtersList
 * @returns Array of filters [{memeber: X, operator: X, values:}]
 * Iterates through the list of filters and values and formats them to fit 
 */

function createFilterList(filtersTemp: any[], filterlist: SearchFilter[]) {
  let filters: SearchFilter[] = []
  filters = filters.concat(filterlist)
  if (filtersTemp.length != 0) {
    [...new Set(filtersTemp.flatMap(Object.keys))].forEach(element => {
      if (element == 'plays.count') {
        return;
      } else if (element == 'venues.state') {
        return;
      } else {
        filters.push({
          "member": element,
          "operator": "equals",
          "values": filtersTemp.map(function (el) { return el[element] }).filter(Boolean)
        })
      }
    });
  }
  return filters
}

</script>

<style>
.tab-open-width {
  width: calc(100% - 20rem) !important;
}

.p-toast-message-icon {
  width: 1.2rem;
  height: 1.5rem;
}

.p-toast-message-content {
  padding: 0.60rem;
  align-items: center;
}

.p-toast .p-toast-message .p-toast-message-content .p-toast-detail {
  margin: 0;
}

.inplace .p-button {
  position: absolute;
  bottom: 2px;
  right: 2px;
}

.inplace .p-button:hover {
  background-color: gray;
}
</style>
